import { render, staticRenderFns } from "./GeneralReceiptListView.vue?vue&type=template&id=f8a9a1d2"
import script from "./GeneralReceiptListView.vue?vue&type=script&lang=js"
export * from "./GeneralReceiptListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports